module.exports = __webpack_public_path__ + "img/utilityvalvac_driving.57ac638a.svg";